var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',{attrs:{"title":"Ödeme Özeti"}},[_c('customer-statistic')],1),_c('customer-history-details',{attrs:{"id-customers":_vm.customerId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }